<template>
  <div class="payment-card">
    <div class="card-info">
      <p v-if="isDefault" class="default-note">Your Default Card</p>

      <div>
        <Sprite :name="card.card.brand" />
        <span>•••• {{ card.card.last4 }}</span>
      </div>

      <div>Expires {{ card.card.exp_month }}/{{ card.card.exp_year }}</div>
    </div>

    <div v-if="showSetDefault">
      <p class="default-text" v-if="isDefault">Default</p>
      <Btn subtle v-else @click="setDefault">Set Default</Btn>
    </div>

    <div v-if="showSelectCard">
      <p class="selected-text" v-if="isSelected">Selected</p>
      <Btn tertiary v-else @click="selectCard">Use this card</Btn>
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite'
import Btn from '@/components/Btn'

export default {
  name: 'payment-card',

  props: {
    card: Object,
    customer: Object,
    showSetDefault: Boolean,
    showSelectCard: Boolean,
    selectedId: String
  },

  components: {
    Sprite,
    Btn
  },

  computed: {
    isDefault() {
      let customerDefault = this.customer.invoice_settings
        ? this.customer.invoice_settings.default_payment_method
        : {}

      return this.card.id === customerDefault || false
    },

    isSelected() {
      return this.card.id === this.selectedId
    }
  },

  methods: {
    setDefault() {
      this.$emit('setDefault', this.card)
    },

    selectCard() {
      this.$emit('selectCard', this.card.id)
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.payment-card
  margin-bottom: $gap-small
  display: flex
  width: 100%
  align-items: center
  font-size: 14px
  position: relative

  .default-note
    position: absolute
    top: 0
    text-transform: uppercase
    font-weight: bold
    right: $gap-small
    font-size: 7px

    @include themify($themes)
      color: themed('color-primary')

  .sprite
    width: 40px
    height: 40px
    margin-right: $gap-small

  div
    display: flex
    align-items: center

  .btn, .default-text, .selected-text
    min-width: 150px
    text-align: center

  .card-info
    @extend %card
    padding: $gap-small
    display: flex
    justify-content: space-between
    align-items: center
    margin-right: $gap-medium
    flex: 1
</style>
